module.exports = __webpack_public_path__ + "static/media/district55.1e07ad43.pdf";